import { render, staticRenderFns } from "./ParticipantLink.vue?vue&type=template&id=0ab41372&scoped=true&"
import script from "./ParticipantLink.vue?vue&type=script&lang=js&"
export * from "./ParticipantLink.vue?vue&type=script&lang=js&"
import style0 from "./ParticipantLink.vue?vue&type=style&index=0&id=0ab41372&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab41372",
  null
  
)

export default component.exports